import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { UserInfo } from '../../../userInfo';
import { AuthService } from '../../../core/auth.service';
import { MetadataService } from '../../../shared/services/metadata.service';
import { SharedHandlersService } from '../../../shared/shared-handlers.service';
import { Router } from '@angular/router';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ConfirmationDialog } from '../../../shared/confirmation-dialog/confirmation-dialog.component';


import Swal from 'sweetalert2';
import * as $ from 'jquery';
import { TranslateService } from '@ngx-translate/core';
import { HttpUrlEncodingCodec } from '@angular/common/http';
import { MenuItemsService } from 'src/app/shared/services/menu-items/menu-items.service';
import { AppConfigService } from '../../services/app-config.service';
import { HttpClient } from '@angular/common/http';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs';
import { BISideBarComponent } from 'BI-Libraries/BI-Components/dist/bi-modules';
import { AdminRouteGuard } from 'src/app/core/admin-route.guard';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit , AfterViewInit {
  @ViewChild(BISideBarComponent) biSidebar: BISideBarComponent;
  // reportMangerList:any;
  menuItems: any;
  langVar: number;
  username: string;
  BU: string;
  BUID: string;
  BUA: string;
  checkChange: boolean = false;
  hasChange: boolean = false;
  dialogRef: MatDialogRef<ConfirmationDialog>;
  clearMenuCache: boolean;
  public isCollapsed = false;
  codec = new HttpUrlEncodingCodec;
  mobile: boolean = false;
  excludedFromSearchIndexes: number[]


  constructor(private _router: Router,
    public Shared: SharedHandlersService,
    private _authService: AuthService,
    private metaDataService: MetadataService,
    public dialog: MatDialog,
    private _authJWTService: AdminRouteGuard,
    public translate: TranslateService,
    public menuItemsService: MenuItemsService,
    public _HttpClient: HttpClient,
    private environment: AppConfigService,
    private breakpointObserver: BreakpointObserver

  ) {
    this.excludedFromSearchIndexes = [this.menuItemsService.onTheFlyModulesIndexes.favorite, this.menuItemsService.onTheFlyModulesIndexes.recent];
    if(this.isLoggedIn()){
      // this.menuItemsService.getReportManger().subscribe(res=>{
      //   this.reportMangerList= res;
      // })
  }
  }

  ngOnInit(): void {

    this.BU = UserInfo.BusinessUnitName;
    this.BUA = UserInfo.BusinessUnitAName;
    this.BUID = UserInfo.BUID;
    this.username = UserInfo.UserName;
    this.menuItemsService.InitMenuItems();
    this.Shared.getGridChange().subscribe(async message => {
      this.checkChange = message.text;
    });
    this.Shared.getClearCacheEvent().subscribe(async message => {
    });
    //this.callPowerBiDashboard()
    const mobileQuery = this.breakpointObserver.observe('(max-width: 576px)');

    mobileQuery.pipe(
      map((result) => result.matches)
    ).subscribe((matches) => {
      this.mobile = matches;
    });
  }
  ngAfterViewInit(): void {
    if (this.mobile)
      this.biSidebar.closeMenu()
  }
  isLoggedIn() {
    return this._authJWTService.isLoggedIn();
  }

  navigateToDashboard() {
    this._router.navigate(['/'])
  }

  async login() {
    await this._authService.login();
  }

  async menuClick(isDashboard: boolean, TemplateRoute: string, ScreenId: string, QueryStringParam: string = '') {
    if (this.checkChange) {
      Swal.fire({
        html: `<div>${this.translate.instant('Confirm')}</div><div style=font-size:15px>${this.translate.instant('ConfirmSaveChanges')}</div>`,
        showCloseButton: true,
        showConfirmButton: true,
        showCancelButton: true,
        buttonsStyling: false,
        cancelButtonText: this.translate.instant('Cancel'),
        confirmButtonText: this.translate.instant('Confirm'),
        customClass: {
          confirmButton: 'defaultFontSizeButtonOk',
          cancelButton: 'defaultFontSizeButtonCancel'
        }
      }).then(async (result) => {
        if (result.value) {
          await this.Shared.sendGridChangeSave(true);
          this.RemoveLocalStorage();
          if (isDashboard)
            this._router.navigate(['/']);
          else {
            if (QueryStringParam !== '' && QueryStringParam != null && QueryStringParam != undefined) {
              let queryParam = QueryStringParam.split('=');
              this._router.navigate(['Supervisor/' + TemplateRoute + '/' + ScreenId],
                { queryParams: { Module: queryParam[1] } })
            }
            else
              this._router.navigate(['Supervisor/' + TemplateRoute + '/' + ScreenId]);
          }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          await this.Shared.sendGridChangeSave(false);
          this.RemoveLocalStorage();
          if (isDashboard)
            this._router.navigate(['/']);
          else {
            if (QueryStringParam !== '' && QueryStringParam != null && QueryStringParam != undefined) {
              let queryParam = QueryStringParam.split('=');
              this._router.navigate(['Supervisor/' + TemplateRoute + '/' + ScreenId],
                { queryParams: { Module: queryParam[1] } })
            }
            else
              this._router.navigate(['Supervisor/' + TemplateRoute + '/' + ScreenId]);
          }
        }
      });
    }
    else {
      this.RemoveLocalStorage();
      if (isDashboard)
        this._router.navigate(['/']);
      else {
        if (QueryStringParam !== '' && QueryStringParam != null && QueryStringParam != undefined) {
          let queryParam = QueryStringParam.split('=');
          this._router.navigate(['Supervisor/' + TemplateRoute + '/' + ScreenId],
            { queryParams: { Module: queryParam[1] } })
        }
        else
          this._router.navigate(['Supervisor/' + TemplateRoute + '/' + ScreenId]);
      }
    }
  }

  RemoveLocalStorage() {
    //remove filter local storage
    let keys = Object.keys(localStorage);
    var i, results = [];
    for (i in localStorage) {
      if (localStorage.hasOwnProperty(i)) {
        if (i.match('FilterValues') || (!'FilterValues' && typeof i === 'string')) {
          localStorage.removeItem(i);
        }
      }
    }
   // this.Filter.condition = undefined;
  }
  ngEncode(param: string) {
    return this.codec.encodeValue(param);
  }
  callPowerBiDashboard() {
    // this._HttpClient.get(this.environment.oDataApi + '/GetAllBiBoards').subscribe((data: any) => {
    //   let AddedPath = []
    //   data.value.forEach(e => {
    //     AddedPath.push({ text: e['DashboardName'], path: e['DashboardURL'] })
    //   })
    //   this.menuItemsService.items.forEach(element => {
    //     if (element.text == 'Reports') {
    //       element.children.forEach(el => {
    //         if (el.text == "ConfiguredReports") {
    //           el.children = AddedPath

    //         }
    //       })
    //     }
    //   });
    // })
  }
}
